export default {
  header: {
    title: 'Promo code or Gift card',
  },
  available_codes: {
    title_one: 'Available code ({{count}})',
    title_other: 'Available codes ({{count}})',
    min_threshold: 'Min {{value}}',
    percentage_off: '{{discount}}% off this order',
    amount_off: '{{amount}} off this order',
  },
  content: {
    input: {
      placeholder: 'Enter a code',
    },
    buttons: {
      done: 'Done',
      apply: 'Apply',
      applied: 'Applied ✓',
    },
  },
};
